import React from 'react';

import PropTypes from 'prop-types';

const Section = ({ className, children, cols, padding, overflow }) => {
  const getColsClass = (c) => {
    const map = {
      1: 'basis-1/12 max-w-[8.333333%]',
      2: 'basis-2/12 max-w-[16.666667%]',
      3: 'basis-3/12 max-w-[25%]',
      4: 'basis-4/12 max-w-[33.333333%]',
      5: 'basis-5/12 max-w-[41.666667%]',
      6: 'basis-6/12 max-w-[50%]',
      7: 'basis-7/12 max-w-[58.333333%]',
      8: 'basis-8/12 max-w-[66.666667%]',
      9: 'basis-9/12 max-w-[75%]',
      10: 'basis-10/12 max-w-[83.333333%]',
      11: 'basis-11/12 max-w-[91.666667%]',
      12: 'basis-full max-w-full',
    };
    return map[c] || map[12];
  };

  const getPaddingClass = () => {
    if (typeof padding === 'string') return padding;
    if (padding) return 'py-[1.5em] px-[1em]';
    return '';
  };

  const getOverflowClass = () => {
    if (overflow === false || overflow === 'hidden') return 'overflow-hidden';
    if (typeof overflow === 'string') return `overflow-${overflow}`;
    return 'overflow-auto';
  };

  return (
    <div className={`relative flex-none h-full m-0 ${className || ''} ${getColsClass(cols)}`}>
      <div className={`absolute inset-0 w-full h-full ${getOverflowClass()} ${getPaddingClass()}`}>
        {children}
      </div>
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  cols: PropTypes.number,
  padding: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  overflow: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
};

Section.defaultProps = {
  className: null,
  children: null,
  cols: 12,
  padding: false,
  overflow: 'auto',
};

export default Section;
